export default __webpack_public_path__ + "static/media/web-rc-2021.41418b23.png";